import React from 'react';

interface UserNoticeModalProps {
  onAccept: () => void;
}

export const UserNoticeModal: React.FC<UserNoticeModalProps> = ({ onAccept }) => {
  return (
    <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50 p-4">
      <div className="bg-white dark:bg-gray-800 rounded-lg shadow-xl max-w-2xl w-full p-6">
        <h2 className="text-2xl font-bold text-gray-900 dark:text-white mb-4">
          User Notice
        </h2>
        
        <div className="space-y-4 text-gray-700 dark:text-gray-300 mb-6">
          <p className="font-semibold">
            ⚠️ This is a demonstration application. Do not upload internal, confidential, or otherwise sensitive information.
          </p>
          
          <p>
            This application is designed to showcase knowledge base assistant capabilities using Amazon Bedrock and AWS services. It demonstrates how AI can retrieve and synthesise information from document collections to answer questions.
          </p>
          
          <p>
            By continuing, you acknowledge that you understand this is a demonstration environment and agree to use it responsibly without sharing sensitive or confidential information.
          </p>
        </div>
        
        <button
          onClick={onAccept}
          className="w-full bg-blue-600 hover:bg-blue-700 text-white font-semibold py-3 px-4 rounded-lg transition-colors"
        >
          I Understand
        </button>
      </div>
    </div>
  );
};
